module.exports = __webpack_public_path__ + "img/workshop-marker-green-v2.9e92979a.png";